export default __webpack_public_path__ + "18ee169497e318462f02618809120d23.png";